export const INTERACTION_TYPES = [
  'cta_click',
  'link_click',
  'modal_open',
  'modal_close',
  'accordion_expand',
  'accordion_collapse',
  'tab_select',
  'video_play',
  'video_complete',
  'video_milestone',
  'scroll_milestone',
  'carousel_slide',
  'calculator_interact',
  'form_focus',
  'form_submit',
  'quality_session',
] as const;

export type InteractionType = (typeof INTERACTION_TYPES)[number];

export const VALID_INTERACTION_TYPES: ReadonlySet<string> = new Set(INTERACTION_TYPES);

export const DEBOUNCED_TYPES: ReadonlySet<InteractionType> = new Set([
  'calculator_interact',
  'carousel_slide',
]);

export interface InteractionEvent {
  event: 'user_interaction' | 'quality_session';
  interaction_id: string;
  interaction_section: string;
  interaction_type: InteractionType;
  interaction_text: string;
  interaction_destination: string | null;
  element_position_y: number | null;
  page_path: string;
  page_referrer: string;
  page_internal_referrer: string | null;
  page_language: string;
  scroll_depth_percent: number;
  time_on_page_seconds: number;
  session_page_count: number;
  viewport_type: 'desktop' | 'tablet' | 'mobile';
  viewport_width: number;
  utm_source: string | null;
  utm_medium: string | null;
  utm_campaign: string | null;
  is_first_visit: boolean;
  click_timestamp: number;
  // Dynamic experiment variant params (e.g., exp_pro_page_part_ii: 'control')
  [key: `exp_${string}`]: string;
}
